import { defineComponent as _defineComponent } from 'vue'
import { defineMessages } from '@/lib/i18n';
import { reactive, ref } from 'vue';
import { VForm } from 'vuetify/lib/components';
import { store } from '@/store/index';
import sharedMessages from '@/lib/shared-messages';
import BaseButtonSubmit from '@/views/base/BaseButtonSubmit.vue';
import { readCompany } from '@/store/main/getters';
import { usePermissionComposable } from '@/composables/usePermission';
import { i18n } from '@/plugins/vue-i18n';
import {
  dispatchGetCompany,
  dispatchUpdateCompanySettings,
} from '@/store/main/actionsMain';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanySdsRevisionCopyFieldsForm',
  setup(__props) {

const $t = i18n.t.bind(i18n);
const { hasPermission, PERMISSIONS: P } = usePermissionComposable();
const company = reactive({ ...readCompany(store) });

const isValidForm = ref<boolean>(false);
const form = ref<InstanceType<typeof VForm> | null>(null);
const isLoading = ref<boolean>(false);

const m = defineMessages({
  revisionCopySettingsDescription:
    '最新版のSDSが登録されたときに、同一製品の旧版SDSから自動的に以下の項目をコピーするかを設定できます。',
  tags: 'タグのコピー',
  departments: '担当部署のコピー',
  product_code_list: '製品コードのコピー',
  sds_assignees: '担当ユーザーのコピー',
  note: '備考のコピー',
});

const items = [
  { key: 'tags', label: $t(m.tags) },
  { key: 'departments', label: $t(m.departments) },
  { key: 'product_code_list', label: $t(m.product_code_list) },
  { key: 'sds_assignees', label: $t(m.sds_assignees) },
  { key: 'note', label: $t(m.note) },
];

const sdsRevisionCopyFields = ref<
  Record<(typeof items)[number]['key'], boolean>
>(
  Object.fromEntries(
    items.map(({ key }) => [
      key,
      company.sds_revision_copy_fields?.[key] || false,
    ])
  )
);

const submit = async () => {
  if (!form.value) return;
  const valid = await form.value.validate();
  if (!valid) return;

  isLoading.value = true;
  try {
    await dispatchUpdateCompanySettings(store, {
      params: {
        companyId: company.uuid,
      },
      payload: {
        sds_revision_copy_fields: sdsRevisionCopyFields.value,
      },
    });
    await dispatchGetCompany(store, { companyId: company.uuid });
  } finally {
    isLoading.value = false;
  }
};

return { __sfc: true,$t, hasPermission, P, company, isValidForm, form, isLoading, m, items, sdsRevisionCopyFields, submit, VForm, sharedMessages, BaseButtonSubmit }
}

})